var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinIconV3 = function SvgLinkedinIconV3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M18 17h-3.978v-5.976c0-1.564-.623-2.632-1.991-2.632-1.047 0-1.629.72-1.9 1.415-.101.25-.085.596-.085.944V17H6.104s.051-10.586 0-11.549h3.942v1.813c.232-.793 1.492-1.924 3.502-1.924C16.04 5.34 18 7.002 18 10.58zM2.119 4.007h-.026C.823 4.007 0 3.124 0 2.005 0 .865.848 0 2.143 0s2.09.862 2.116 2.002c0 1.119-.822 2.005-2.14 2.005M.454 5.451h3.508V17H.454z"
  })));
};
export default SvgLinkedinIconV3;